import React, { useEffect } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import AgileUploadRow from '@components/agile/types/AgileUploadRow';
import { ERROR_COLOR } from 'src/constants/values';
import Icon from '@amzn/meridian/icon';
import trashTokens from '@amzn/meridian-tokens/base/icon/trash';
import Button from '@amzn/meridian/button';
import { AgileMacroplanogram } from '@components/agile/types/AgileMacroplanogramTypes';

const DeleteButtonCellRenderer = (params: {
  node: ICellRendererParams;
  setRowData: (value: AgileUploadRow[]) => void;
  rowData: AgileUploadRow[];
  setTotalNewFacings: (value: number) => void;
  setDisableButton: (value: boolean) => void;
  setMaxFacingFlag: (value: boolean) => void;
  setRecommendationFlag: (value: boolean) => void;
  setInputFlag: (value: boolean) => void;
  zoneDetails: AgileMacroplanogram | undefined;
}) => {
  const {
    node,
    setRowData,
    rowData,
    setTotalNewFacings,
    setDisableButton,
    setMaxFacingFlag,
    zoneDetails,
    setRecommendationFlag,
    setInputFlag,
  } = params;
  const disableRecomendationButton = () => {
    const listOfCapacity = rowData.map((obj) => obj.fohCapacity.capacity);
    const listOfsubcategoryId = rowData.map((obj) => obj.subcategoryId);
    return listOfCapacity.includes(null) || listOfCapacity.includes(0) || listOfsubcategoryId.includes(undefined);
  };

  useEffect(() => {
    const total: number = rowData ? rowData.reduce((t, obj) => t + parseInt(String(obj.facingUnits), 10), 0) : 0;
    setTotalNewFacings(total);
    setMaxFacingFlag(total > Number(zoneDetails?.maxFacingUnits));
    setDisableButton(disableRecomendationButton());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData, setDisableButton, setMaxFacingFlag]);

  const onClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const result = rowData.filter((row) => row.asin !== node.data.asin);
    if (result.length === 0) {
      setRecommendationFlag(false);
      setInputFlag(false);
      setRowData([]);
    } else {
      setRowData(result);
    }
  };
  return (
    <Button className={ERROR_COLOR} type="icon" onClick={onClick}>
      <Icon tokens={trashTokens} />
    </Button>
  );
};

export default DeleteButtonCellRenderer;
